import { useMutation } from '@tanstack/react-query'
import { startTranscription } from '../../../data/transcriptionAI/startTranscription'
import { UserFriendlyError } from '../../../model/Error'
import { transcriptionAIKeys } from './transcriptionAI.keys'

export const useStartTranscription = () => {
  return useMutation({
    mutationKey: transcriptionAIKeys.start,
    mutationFn: async () => {
      const { data, ok } = await startTranscription()

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de démarrer une transcription`,
          `Une erreur technique s'est produite`,
        )
      }

      return data
    },
  })
}
